module.exports = __webpack_public_path__ + "static/img/0770.0308f2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0770.jpg
// module id = 108
// module chunks = 0